const LOCALE_PREFIX_RE = /^\/[a-z]{2}-[a-z]{2}(\/|$)/

/**
 * Returns true if the href points to a different host than baseUrl.
 * Relative paths are always considered internal.
 */
export function isExternalUrl(href: string, baseUrl: string): boolean {
  if (!href.startsWith('http://') && !href.startsWith('https://')) return false
  try {
    return new URL(href).host !== new URL(baseUrl).host
  } catch {
    return false
  }
}

/** Returns true if the path already has a locale prefix (e.g. /de-de/, /en-us/). */
export function hasLocalePrefix(path: string): boolean {
  return LOCALE_PREFIX_RE.test(path)
}

/**
 * Extracts the path from an absolute URL (pathname + search + hash).
 * Returns the href unchanged if it is already a relative path.
 */
export function toPath(href: string): string {
  if (!href.startsWith('http://') && !href.startsWith('https://')) {
    return href.startsWith('/') ? href : `/${href}`
  }
  try {
    const url = new URL(href)
    return url.pathname + url.search + url.hash
  } catch {
    return href.startsWith('/') ? href : `/${href}`
  }
}
